import type { ChangeEvent, RefObject } from 'react';

import MotionEditorWorldAddMenu from './MotionEditorWorldAddMenu';
import type {
  MotionEditorWorldAddMenuState,
  MotionEditorWorldAssetFormat,
  MotionEditorWorldPrimitiveType,
} from './types';

interface MotionEditorWorldObjectControlsProps {
  assetInputRef: RefObject<HTMLInputElement | null>;
  menu: MotionEditorWorldAddMenuState;
  onAddPrimitive: (type: MotionEditorWorldPrimitiveType) => void;
  onAssetInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onCloseAddMenu: () => void;
  onImportAsset: (format: MotionEditorWorldAssetFormat) => void;
}

export function MotionEditorWorldObjectControls({
  assetInputRef,
  menu,
  onAddPrimitive,
  onAssetInputChange,
  onCloseAddMenu,
  onImportAsset,
}: MotionEditorWorldObjectControlsProps) {
  return (
    <>
      <MotionEditorWorldAddMenu
        menu={menu}
        onAddPrimitive={onAddPrimitive}
        onClose={onCloseAddMenu}
        onImportAsset={onImportAsset}
      />
      <input
        ref={assetInputRef}
        type="file"
        accept=".glb,.obj"
        className="hidden"
        onChange={onAssetInputChange}
      />
    </>
  );
}
